module.exports = __webpack_public_path__ + "img/info.1c042d3b.svg";